import { ChangelogType } from "../Enums";

export class ChangeCategory {
  title: ChangelogType;
  logs: string[] = [];
}
